import { Button } from "@fluentui/react-components";
import { DocumentTableRegular } from "@fluentui/react-icons";
import { ExportExcelHandle } from "../ImportedInvoiceEntriesGrid/ExportExcel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useImportedInvoicesStore } from "store/ImportedInvoicesStore";
import { ImportedInvoice } from "types/importedInvoices";

type Props = {
  refExcelExport: React.RefObject<ExportExcelHandle>;
};

// exports the visible invoices with one row per entry
export const ExportExcelButton = ({ refExcelExport }: Props) => {
  const { t } = useTranslation();
  const [
    { importedInvoicesLoadStatus, importedInvoices, importedInvoiceMetadataMap },
  ] = useImportedInvoicesStore();

  const hasVisibleInvoices = (importedInvoices ?? []).some(
    (invoice: ImportedInvoice) =>
      importedInvoiceMetadataMap[invoice.importedInvoiceId]?.visible === true
  );

  return (
    <Button
      data-help="imported-invoices-export-excel"
      appearance="subtle"
      icon={<DocumentTableRegular fontSize={24} />}
      disabled={importedInvoicesLoadStatus === "loading" || !hasVisibleInvoices}
      onClick={() => {
        refExcelExport.current?.save();
      }}
    >
      {t("greco.exportExcel")}
    </Button>
  );
};
